/**
 * addit Theme — Amino Acid Bar Chart Animation
 * Uses IntersectionObserver to animate bar widths on scroll.
 * Bars with data-natural-width (added amino acids) grow in two steps: first the part that comes
 * from collagen, then the added part extends the bar and its "Zugesetzt" tag fades in. Container
 * width and the added part's flex-grow share one duration and easing, so the collagen part keeps
 * its width while the added part grows.
 */

(function () {
  'use strict';

  var STAGGER = 80;
  var STEP = 1000;

  function initChart(chart) {
    var bars = chart.querySelectorAll('[data-bar-width]');
    if (!bars.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    chart.classList.add('js-amino');

    Array.prototype.forEach.call(bars, function (bar) {
      var added = bar.querySelector('[data-added-grow]');
      if (added && !reduce) added.style.flexGrow = '0';
    });

    function finish(bar) {
      var added = bar.querySelector('[data-added-grow]');
      bar.style.width = bar.dataset.barWidth + '%';
      if (added) added.style.flexGrow = added.dataset.addedGrow;
      var row = bar.closest('.amino-chart__row');
      if (row) row.classList.add('is-added');
    }

    if (reduce) {
      Array.prototype.forEach.call(bars, finish);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          Array.prototype.forEach.call(bars, function (bar, index) {
            var delay = index * STAGGER;
            if (bar.dataset.naturalWidth !== undefined) {
              setTimeout(function () { bar.style.width = bar.dataset.naturalWidth + '%'; }, delay);
              setTimeout(function () { finish(bar); }, delay + STEP + 150);
            } else {
              setTimeout(function () { bar.style.width = bar.dataset.barWidth + '%'; }, delay);
            }
          });
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(chart);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-amino-chart]'), initChart);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
